// extracted by mini-css-extract-plugin
export default {"container":"Jk-z","bubbleNav":"Kk-z","graphic":"Lk-z","contact":"Mk-z"};